'use strict';

export class ApplicationResolutionCtrl
{
	$scope;
	$filter;
	$mdDialog;
	$timeout;
	jsDataService;
	notify;
	classif;
	showRequire = true;
	
	cfg = {
		maxFileSize: 0,
		fileFilter: {},
		uploadUrl: '',
	};
	attachmentUploadUrl;
	attfile = {
		file: {}
	};
	dragClass = '';
	
	postElements = {
		status: null,
		comment: '',
		subject: '',
		attachments: []
	};
	
	constructor($scope, $filter, $timeout, $mdDialog, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.$timeout = $timeout;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.cfg.fileFilter = this.jsDataService.get('cfgFileFilter', {});
		this.cfg.maxFileSize = this.jsDataService.get('maxFileSize', 0);
		this.cfg.uploadUrl = this.jsDataService.get('cfgUploadUrl');
		
	}
	
	fileUploaded($file, $message, $flow){
		if($file.response.success){
			this.attfile.file.file_id = $file.response.fileId;
			this.attfile.file.done = true;
			this.saveAttachment(this.attfile);
		}
	}
	
	filesAdded($files){
		return true;
	}

	fileAdded($file){
		const ext = $file.getExtension();
		if(typeof(this.cfg.fileFilter[ext]) === 'undefined' || !this.cfg.fileFilter[ext]){
//			this.notify(this.$filter('tr')('file_wrong_format'), true);
			return false;
		}
		if(typeof(this.cfg.maxFileSize) !== 'undefined' && $file.size > this.cfg.maxFileSize){
			this.notify($file.name + ' - ' + this.$filter('tr')('file_size_error'), true);
			return false;
		}
		if(!this.activeUpload()){
			return false;
		}
		this.addFlowFile($file);
		return true;
	}
	
	fileSubmited(){
		this.attfile.flow.upload();
	}
	
	activeUpload(){
		return true;
	}

	classOnDrag(value){
		if(this.activeUpload()){
			this.dragClass = value;
		}
	}

	classOffDrag(value){
		this.dragClass = value;
	}
	
	addFlowFile($file){
		let file = {
			file_id: '0',
			nrId: $file.uniqueIdentifier,
			file_name: $file.name,
			isFlow: true,
			flowFile: $file,
			done: false
		};
		this.attfile.file = file;
	}
	
	saveAttachment(attachment){
		let data = {
			file_id: attachment.file.file_id,
			title: attachment.file.file_name
		};
		this.postElements.attachments.push(data);
		this.attfile.file = {};
	}
	
	removeAttachment(ev, attachment){
		this.postElements.attachments = this.$filter('filter')(this.postElements.attachments, {file_id: '!'+attachment.file_id}, true);
	}
	
	save(ev, form){
		const url  = this.jsDataService.get('cfgSubmitUrl');
		if(url){
			this.$timeout(()=>{
				if(form.$invalid){
					this.notify(this.$filter('tr')('err_check_required_fields'), true);
				}
				else{
					this.$scope.basicHttpConfigProcess({
						url: url,
						method: 'POST',
						data: this.postElements
					});
				}
			});
		}
	}
}